
    /**
     * @description
     *  Modelo de un domicilio.
     *
     * @see gigot-backend/ViewModels/Domicilio/AddressDto.cs
     */

export class Address {

    public apartment: string;
    public complement: string;
    public floor: string;
    public id: number;
    public latitude: number;
    public locality: string;
    public longitude: number;
    public neighborhood: string;
    public number: string;
    public postalCode: string;
    public province: string;
    public region: string;
    public street: string;
    public type: string;

    /**
     * @description
     *	Construye un domicilio con una semántica vacía. Nótese que no es lo
     *  mismo que construir un domicilio con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un domicilio vacío.
     */
    public static empty(): Address {
        const address: Address = new Address();
        address.apartment = "";
        address.complement = "";
        address.floor = "";
        address.id = undefined;
        address.latitude = undefined;
        address.locality = "";
        address.longitude = undefined;
        address.neighborhood = "";
        address.number = "";
        address.postalCode = "";
        address.province = "";
        address.region = "";
        address.street = "";
        address.type = "";
        return address;
    }

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicAddress
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicAddress: Address): Address {
		if (!anemicAddress) return undefined;
		const address: Address = Address.empty();
		address.apartment = anemicAddress.apartment;
        address.complement = anemicAddress.complement;
        address.floor = anemicAddress.floor;
        address.id = anemicAddress.id;
        address.latitude = anemicAddress.latitude;
        address.locality = anemicAddress.locality;
        address.longitude = anemicAddress.longitude;
        address.neighborhood = anemicAddress.neighborhood;
        address.number = anemicAddress.number;
        address.postalCode = anemicAddress.postalCode;
        address.province = anemicAddress.province;
        address.region = anemicAddress.region;
        address.street = anemicAddress.street;
        address.type = anemicAddress.type;
		return address;
	}
}
